const faqItems = [
  {
    q: '69视频是什么类型的网站？',
    a: '69视频是一个特色视频网站导航与资源聚合平台，汇集丝瓜视频、蓝莓视频、糖心视频、黑桃视频等多家特色视频站点，为用户提供一站式的视频内容发现与观看体验。',
  },
  {
    q: '69视频上的内容需要付费吗？',
    a: '69视频作为导航聚合平台本身完全免费，你可以在平台上自由浏览和发现各类特色视频资源。部分合作站点可能有自己的会员体系，但我们会优先推荐免费可访问的优质内容。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '我们为每个视频资源配备多条播放线路，如果遇到卡顿可以尝试切换线路。同时建议使用Chrome、Edge等现代浏览器，保持网络畅通。我们的资源均为高清画质，建议在WiFi或4G/5G网络下观看获得最佳体验。',
  },
  {
    q: '每天会有新内容更新吗？',
    a: '是的，69视频团队每日持续更新内容资源，覆盖最新上映的热门电影、热播电视剧、综艺节目、动漫番剧等。你可以通过「最新快讯」模块和「视频热度榜」了解每日最新内容动态。',
  },
  {
    q: '如何在手机上使用69视频？',
    a: '69视频采用全响应式设计，在手机、平板、电脑上均可流畅访问。直接通过手机浏览器打开即可获得适配移动端的浏览体验。你也可以收藏本站到手机桌面，方便快速访问。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
            常见问答
          </h2>
          <div className="space-y-4">
            {faqItems.map((item, i) => (
              <details
                key={i}
                className="group bg-background-100 rounded-xl border border-background-200 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.q}
                  </h3>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:rotate-45 transition-transform">
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}